module.exports = __webpack_public_path__ + "img/cocktail-glass.363b795a.png";